<template>
    <div class="master-template-text-filter">
        <Input v-model="masterTemplatesLibraryStore.search" search clearable placeholder="Search..." />
    </div>
</template>

<script lang="ts" setup>
import { useMasterTemplatesLibraryStore } from "@/store/pinia/masterTemplatesLibrary";

const masterTemplatesLibraryStore = useMasterTemplatesLibraryStore();
</script>

<style lang="scss">
@use "@style/variables" as *;

.master-template-text-filter {
    display: flex;
    margin-right: $spacing;
    justify-content: space-between;
    align-items: center;
    width: 200px;
    flex: 0 0 200px;
    margin-right: $spacing;
}
</style>
